module.exports = __webpack_public_path__ + "56c72273081c059dac98781b7f22e553.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C0000AJEN.png
// module id = 1588
// module chunks = 0